"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getMapContainerStyles;

function getMapContainerStyles(ref) {
  if (ref && ref.parentNode) {
    var parentHeight = ref.parentNode.style.height;

    if (!parentHeight) {
      return {
        minHeight: 300
      };
    }

    return null;
  }

  return null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/PresenceMap/getMapContainerStyles.js
// module id = XTQL
// module chunks = 0